var map = {
	"./1.webp": 4269,
	"./2.webp": 5616,
	"./3.webp": 9699,
	"./41.webp": 3437,
	"./51.webp": 4868,
	"./Carlos Alca.webp": 4651,
	"./clasico.webp": 8122,
	"./eredevise.webp": 2638,
	"./euro 2024 champs.webp": 6043,
	"./f1poster.webp": 8094,
	"./laliga.webp": 3798,
	"./liga endesa.webp": 4439,
	"./maroc 2025.webp": 4107,
	"./motogp.webp": 6772,
	"./nascarsports.webp": 8801,
	"./nba.webp": 7637,
	"./olympic 2024 champs.webp": 1201,
	"./roger nadal.webp": 7535,
	"./ufc.webp": 9354
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6994;